export default __webpack_public_path__ + "images/f8106ce238361dffd6b7ba938a21a54d-reframe-negative-thoughts.svg";